import React from "react";
import { Button, message } from 'antd';
import getSize from "../../utils/getSize";
import NHFetch from "../../utils/NHFetch";
import NHTable from '../common/NHTable';
import {NHConfirm} from '../common/NHModal';
import NHExcel from './NHExcel';
import EditForm from './EditForm.js';
import css from './index.css';
import NHContainerFrame from '../common/NHContainerFrame';
import { hasAuth } from '../../utils/NHCore';

const basicUrl = "/bjqqgl";


/**
 * 班级QQ管理
 * @author liudongbin
 * @date 2021年8月21日 13点36分
 * Version: 1.0
 */
class bjqqManage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRows:{},
            formInitData:{},
            frameVisibleMap: {
                tableFlag:true,
                updateFlag:false,
            },
            showOperationBtn: false, //是否显示删除操作按钮
        };
    }
    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
        this.refs.nhTable.filterTableData();
    }

    //是否显示删除按钮
    rowSelectionChange = (selectedRowKeys) => {
        if (selectedRowKeys.length) {
            this.setState({
                showOperationBtn: true
            })
        } else {
            this.setState({
                showOperationBtn: false
            })
        }
    }

    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        this.setState({
            formInitData: record
            }, this.setCurrentPageShow('updateFlag'));
    }


    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('班级QQ信息');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    }

    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {

            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");

        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }

    //修改确定
    handleUpdate=()=>{
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let sendData = {};
            sendData.bjid = formData.pkid;
            sendData.bjqq = formData.bjqq;
            NHFetch(basicUrl+'/update','POST',sendData).then(res =>{
                if (res){
                    if (res.data>=1){
                        message.success("修改成功！");
                        this.setCurrentPageShow('tableFlag'); //显示列表展示页面
                        this.refs.nhTable.filterTableData(); //刷新列表
                    }else {
                        message.error("修改失败，请联系管理员！");
                    }
                }})
        });
    }

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + '/deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    if (res.data>=1){
                        message.success("删除成功！");
                        this.refs.nhTable.filterTableData();
                    } else{
                        message.error("删除失败，请联系管理员！");
                    }
                }
            })
    }

    onImport = () => {
        this.refs.nhExcel.show();
    }

    handleImportSuccess=()=>{
        this.refs.nhTable.filterTableData();
    }


    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '150px',
            }, {
                title: '校区',
                width: '200px',
                dataIndex: 'XQMC',
                searchType:"input"
            }, {
                title: '学院',
                dataIndex: 'BMMC',
                width: '200px',
                search: 'input',
                searchType:"input"
            }, {
                title: '专业',
                dataIndex: 'ZYMC',
                width: '200px',
                search: 'input',
                searchType:"input"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType:"input"
            }, {
                title: '班级QQ',
                width: '200px',
                dataIndex: 'BJQQ',
                searchType:"input"
            }
        ];

        //行内操作
        const action = [
            {title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_bjqqManage_update'},
            {title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_bjqqManage_delete'}
            // {title: '修改', onClick: this.handleUpdateBtnClick},
            // {title: '删除', onClick: this.handleSingleDeleteBtnClick}
        ];

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxgl_jcsj_bjqqgl_queryPage"}
                        columns={columns}
                        action={action}
                        rowSelectionChange={this.rowSelectionChange}>

                        {/* <Button type="primary" ghost onClick={this.onImport} style={{ marginLeft: 10 }}>导入</Button> */}
                        {
                            hasAuth("zhxg_yxgl_bjqqManage_import") ?
                                <Button type="primary" ghost onClick={this.onImport} style={{ marginLeft: 10 }}>导入</Button>
                                : undefined
                        }

                        {/* <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button> */}
                        {
                            hasAuth("zhxg_yxgl_bjqqManage_export") ?
                            <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button>
                            : undefined
                        }

                        {/* {<Button type="danger" ghost style={{
                            marginLeft: 10,
                            display: this.state.showOperationBtn ? undefined : 'none'
                        }}
                        onClick={this.handleMultiDeleteBtnClick}>删除</Button>} */}
                        {
                            hasAuth('zhxg_yxgl_bjqqManage_delete') ?
                                <Button type="danger" ghost style={{
                                    marginLeft: 10,
                                    display: this.state.showOperationBtn ? undefined : 'none'
                                }}
                                onClick={this.handleMultiDeleteBtnClick}>删除</Button>
                                : null
                        } 

                    </NHTable>
                </div>

                <NHContainerFrame ref="nhUpdateModal"
                    title="修改班级QQ信息"
                    visible={this.state.frameVisibleMap.updateFlag}
                    onCancel={this.handleCloseFrame}
                    onOk={this.handleUpdate}
                >
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData}   />
                </NHContainerFrame>

                <NHExcel
                    ref='nhExcel'
                    title={'班级QQ信息导入'}
                    templateName={'班级QQ信息导入模板.xlsx'}  //导入模板名称
                    templateSign={'班级QQ信息导入模板.xlsx'}  //导入模板问标志，主要通过该标志获取文件
                    importUrl={'api/zhxg-yxxt/bjqqgl/import'}
                    onSuccess={this.handleImportSuccess}
                    onCancel={this.onCancel}
                />

            </div>
        );
    }
}
export default bjqqManage;



// WEBPACK FOOTER //
// ./components/bjqqManage/bjqqManage.js